import React from 'react'

import apis from 'browser/app/models/apis'
import { Button } from 'browser/components/atomic-elements/atoms/button/button'
import { IssueTokenDialog } from 'browser/components/domain/user/issue-token-dialog'

/**
 * @uiComponent
 */
interface IIssueTokenButtonProps {
  targetUserId: string
}

export const IssueTokenButton: React.FC<IIssueTokenButtonProps> = ({ targetUserId }) => {
  if (!apis.getSettings().isAdmin) {
    return null
  }

  const openDialog = () => {
    IssueTokenDialog.open({ targetUserId })
  }

  return <Button buttonText="Issue API Token" onClick={openDialog} />
}
